import { FC, useContext } from 'react';
import { Typography } from 'src/components/common/Typography';
import { FooterContext } from 'src/constructors/Footer/FooterConstructor';
import { reachTextParser } from 'src/helpers/utils';
import './styles.scss';

type Props = {
  settings: {
    priority: number;
    styles: Styles;
  };
};
const ProviderBlock: FC<Props> = ({ settings }) => {
  const { styles } = settings;
  const footerConfigs = useContext(FooterContext);

  return (
    <Typography className="label providerBlock_wrapper" variant={'p'} style={styles}>
      {footerConfigs?.content?.businessLegalInfo
        ? reachTextParser(footerConfigs.content.businessLegalInfo)
        : 'BUSINESS_LEGAL_INFO'}
    </Typography>
  );
};
export default ProviderBlock;
